// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"245":"skyon","722":"notFound"}[chunkId] + "." + {"245":"57fa4ca9","722":"37d04ade"}[chunkId] + ".js";
};